module.exports = __webpack_public_path__ + "img/CothinkrJustName.f9411dcc.svg";